import React, { useState } from "react";
import SelecionarBusca from "../../components/SelecionarBusca";
import { Row, Col } from "react-bootstrap";
import { FiltroCabecalho } from "../../components/FiltroCabecalho";
import { ModeloLinha } from "../../core/models/linha";
import { ModeloProduto } from "../../core/models/produto";
import { FiltroLinha, RepositorioLinha } from "../../core/repositories/linhaRepositorio";
import { FiltroProduto, RepositorioProduto } from "../../core/repositories/produtoRepositorio";
import { useToast } from "../../core/contexts/toast";
import { sazonalidadeContexto } from "../../core/contexts/sazonalidadeContexto";
import { useTranslation } from "react-i18next";
import { TipoTela } from "../../core/config/tipoTela";
import MonthRangePicker from "../../components/MonthRangePicker";
import { FiltroSopFinance } from "../../core/repositories/sopFinanceRepositorio";

interface Props {
  titulo: string;
  filtro: FiltroSopFinance;
  permissaoEditar: boolean;
  atualizarFiltro: (filtro: FiltroSopFinance) => void;
  filtrarDados: (filtro: FiltroSopFinance) => void;
}

export default function FiltroPI(props: Props) {
  const { t } = useTranslation();
  const { mostrarToast } = useToast();
  const { lista } = sazonalidadeContexto();
  const [listaLinha, setListaLinha] = useState<ModeloLinha[]>([]);
  const [listaProduto, setListaProduto] = useState<ModeloProduto[]>([]);

  React.useEffect(() => {
    try {
      // carregarGerencia();
      carregarLinha();
      carregarProduto();
    } catch (error) {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    }
  }, []);

  // function carregarGerencia() {
  //   props.filtro.cod_gerencia = ""
  //   const filtro = new FiltroGerencia();
  //   filtro.cod_canal = "1";
  //   new RepositorioGerencia().getFilter(filtro).then((res) => {
  //     setListaGerencia(res);
  //   });
  // }

  function carregarProduto() {
    props.filtro.cod_produto_capitao = ""
    const filtroProduto = new FiltroProduto();
    filtroProduto.cod_familia_subgrupo = props.filtro.cod_familia_subgrupo_produto_capitao;
    filtroProduto.cod_linha = props.filtro.cod_linha_produto_capitao;
    new RepositorioProduto().getFilter(filtroProduto).then((res) => {
      setListaProduto(res);
    });
  }

  function carregarLinha() {
    props.filtro.cod_linha_produto_capitao = ""
    const filtroLinha = new FiltroLinha();
    filtroLinha.cod_familia_subgrupo = props.filtro.cod_familia_subgrupo_produto_capitao;

    new RepositorioLinha().getFilter(filtroLinha).then((res) => {
      setListaLinha(res);
    });
  }

  return (
    <div className="stick">
      <FiltroCabecalho
        titulo={props.titulo}
        filtro={props.filtro}
        atualizarFiltro={props.atualizarFiltro}
        lista={lista}
        tipoTela={TipoTela.SAZONALIDADE}
      >
        <>
          <Row className="row-cols-2 row-cols-lg-7">

            <Col>
             <MonthRangePicker
                startDate={props.filtro.dth_inicio}
                endDate={props.filtro.dth_fim}
                onRangeChange={(start, end) => {
                  props.filtro.dth_inicio = start;
                  props.filtro.dth_fim = end;
                  props.atualizarFiltro(props.filtro)
                }} />
            </Col>

            <Col>
              <SelecionarBusca
                titulo={t("Business Unit")}
                optionLabel="des_linha"
                optionValue="cod_linha"
                multiple
                value={props.filtro.cod_linha_produto_capitao}
                options={listaLinha}
                onChange={(value) => {
                  props.filtro.cod_linha_produto_capitao = value
                  carregarProduto();
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>

            <Col>
              <SelecionarBusca
                titulo={t("Region")}
                optionLabel="des_produto"
                optionValue="cod_produto"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_produto_capitao}
                options={listaProduto}
                onChange={(value) => {
                  props.filtro.cod_produto_capitao = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>

            <Col>
              <SelecionarBusca
                titulo={t("Product Family")}
                optionLabel="des_produto"
                optionValue="cod_produto"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_produto_capitao}
                options={listaProduto}
                onChange={(value) => {
                  props.filtro.cod_produto_capitao = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>

            <Col>
              <SelecionarBusca
                titulo={t("Product")}
                optionLabel="des_produto"
                optionValue="cod_produto"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_produto_capitao}
                options={listaProduto}
                onChange={(value) => {
                  props.filtro.cod_produto_capitao = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>



            {/* <ValueComponent value={props.filtro.value} atualizarFiltro={(value:any) => { props.filtro.value = value; props.atualizarFiltro(props.filtro) }}></ValueComponent> */}

            {/* <Col>
              <SelecionarBusca
                titulo={t("Forecast in Units")}
                optionLabel="des_produto"
                optionValue="cod_produto"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_produto_capitao}
                options={listaProduto}
                onChange={(value) => {
                  props.filtro.cod_produto_capitao = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>
            <Col>
              <SelecionarBusca
                titulo={t("Average Sales Price")}
                optionLabel="des_produto"
                optionValue="cod_produto"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_produto_capitao}
                options={listaProduto}
                onChange={(value) => {
                  props.filtro.cod_produto_capitao = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col> */}







          </Row>
        </>
      </FiltroCabecalho>
    </div>
  );
}


